import { createContext, PropsWithChildren, useMemo } from 'react'

import Theme, { ThemeProps } from './Theme'

export type Context = {
  fluid?: boolean
  theme?: ThemeProps['theme']
}

export const ThemeContext = createContext<Context | undefined>(undefined)

const ThemeProvider = ({
  children,
  theme,
  fluid = false
}: PropsWithChildren<Context>) => {
  const contextValue = useMemo(() => ({ fluid }), [fluid])

  return (
    <ThemeContext.Provider value={contextValue}>
      <Theme theme={theme} fluid={fluid} />
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
